import React from 'react';

import styles from './IllustrationPlaceholder.css';

const IllustrationPlaceholder = () => {
  return <div className={styles.height} />;
};

export default IllustrationPlaceholder;
